import { Project } from '@/modules/nomenclature/models/project';
import { Location } from '@/modules/nomenclature/models/location';
import { BudgetLine } from './budgetLine';

/**
 * Node entity of the nomenclature v-tree component
 */
export interface TreeNode {
  // Entity attributes
  id?: string;
  parentId?: string | null;
  name: string;
  trigram?: string;
  icon?: string;
  // Tree data
  children?: TreeNode[];
  hiddenChildren?: TreeNode[];
  // Node properties
  nodeType: NodeType;
  depth?: number;
  isLeaf?: boolean;
  // UI properties
  menuCreate?: boolean;
  menuEdit?: boolean;
  menuDelete?: boolean;
}

/**
 * NodeType is used when tree has heterogeneous nodes
 */
export enum NodeType {
  VIRTUAL = 'VIRTUAL',
  LOCATION = 'LOCATION',
  PROJECT = 'PROJECT',
  BUDGET_LINE = 'BUDGET_LINE'
}

export function mapLocationToTreeNode(location: Location, depth: number | undefined = undefined): TreeNode {
  const locationNode: TreeNode = {
    id: location.id,
    icon: location.icon,
    name: location.name,
    trigram: location.trigram,
    isLeaf: location.isLeaf,
    parentId: location.parentId,
    children: [],
    nodeType: NodeType.LOCATION,
    depth
  };

  return locationNode;
}

export function mapProjectToTreeNode(project: Project, depth: number | undefined = -2): TreeNode {
  const projectNode: TreeNode = {
    id: project.id,
    name: project.name,
    parentId: project.parentId,
    children: [],
    nodeType: NodeType.PROJECT,
    depth
  };
  if (project.budgetLines) {
    const budgetLineNodes = project.budgetLines.map((budgetLine) => {
      return mapBudgetLineToTreeNode(budgetLine, project.id as string, depth + 1);
    });
    projectNode.hiddenChildren = budgetLineNodes;
  }

  return projectNode;
}

export function mapBudgetLineToTreeNode(
  budgetLine: BudgetLine,
  parentId: string,
  depth: number | undefined = -2
): TreeNode {
  const budgetLineNode: TreeNode = {
    id: budgetLine.id,
    parentId: parentId,
    name: budgetLine.name,
    icon: budgetLine.icon,
    depth,
    nodeType: NodeType.BUDGET_LINE
  };

  return budgetLineNode;
}
